import React, { useState, useEffect } from "react";
import TransactionDetails from "./transactionDetails";
import { useAuth } from "../../context/API_Client";
import SalesChart from "../salesChartHardCodedData";
import SuccessChart from "../successChart";
import DownloadAndDropdown from "../analytics/downloadAndDropdown";
import Skeleton from "@mui/material/Skeleton";
import {
  getCalendarInterval,
  getCalendarIntervalForGraph,
  getCustomDateRange,
  getPaymentMethodCategories,
  getUTCDayRange,
  getUTCDayRangePercentage,
  isEmpty,
  sortArrayValue,
} from "../utils/utils";
import ProcessorAndPaymentCategoriesCard from "./ProcessorAndPaymentCategoriesCard";
import HomeKpi from "./HomeKpi";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { kpiCalls } from "../analytics/KPICalls";

function Home() {
  const {
    getAllVisualizationData,
    merchantSettings,
    getAllModalData,
    postPspConfigForFiltering,
    getPaymentMethod,
    getAllPspConfigs,
    getAllVisualizationFilterData
  } = useAuth();

  const [gmvPspData, setGmvPspData] = useState([]);
  const [transactionByPsp, setTransactionByPsp] = useState([]);
  const [chartTransactionOverAll, setChartTransactionOverAll] = useState([]);
  const [volumeTransactionOverAll, setVolumeTransactionOverAll] = useState([]);
  const [successRateData, setSuccessRateData] = useState([]);
  const [successRatePercentage, setSuccessRatePercentage] = useState([]);
  const [successRateDifference, setSuccessRateDifference] = useState([]);
  const [locale, setLocale] = useState("");
  const [loading, setLoading] = useState(true);
  const [prevFlag, setPrevFlag] = useState(true);
  const [singleStartDate, setSingleStartDate] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [paymentError, setPaymentError] = useState([]);
  const title = "Transactions by Categories";
  const title2 = "Transactions by Processors";
  const value = "Value";
  const backgroundColor = "white";

  const [selectedDropdownValue, setSelectedDropdownValue] = useState(
    localStorage.getItem("selectedDropdownValue") || "today"
  );

  const [successFilterValue, setSuccessfilterValue] = useState("");
  const [successRateDetails, setSuccessRateDetails] = useState([]);
  const [configPaymentData, setConfigPaymentData] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [filteredCurrency, setFilteredCurrency] = useState([]);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState("");
  const [selectedFilterCurrency, setSelectedFilterCurrency] = useState(
    localStorage.getItem("selectedFilterCurrency") || ""
  );
  const [transactionVolumeData, setTransactionVolumeData] = useState({});
  const [totalPaymentData, setTotalPaymentData] = useState({});
  const [successfulPaymentData, setSuccessfulPaymentData] = useState({});
  const [logo, setLogo] = useState();
  const [paymentData, setPaymentData] = useState();
  const [paymentMethodReport, setPaymentMethodReport] = useState([]);
  const [difference, setDifference] = useState();
  const [allModalData, setAllModalData] = useState();

  useEffect(() => {
    merchantSettings(
      function (data) {
        setLocale(data?.locale);
      },
      function (errorMsg) { }
    );
  }, []);

  const handleFilterDropdown = (graphFilterValue) => {
    setSuccessfilterValue(graphFilterValue);
  };

  // bussiness unit
  const handleBussinessUnitChange = (businessUnit) => {
    setSelectedBusinessUnit(businessUnit);
  };
  // currency
  const handleCurrencyFilterChange = (currencyValue) => {
    setSelectedFilterCurrency(currencyValue);
    localStorage.setItem("selectedFilterCurrency", currencyValue);
  };
  // date
  const handleDropdownChange = (value) => {
    setSelectedDropdownValue(value);
    // if (value !== "customDate") {
    localStorage.setItem("selectedDropdownValue", value);
    // }
  };

  const handleRefreshButton = () => {
    setRefresh(!refresh);
  };

  // Download and DropDown Component ---start
  useEffect(() => {
    // postPspConfigForFiltering(
    //   {},
    //   function (data) {
    //     let businessUnit = []
    //     if (data?.legalEntities?.length) {
    //       businessUnit = sortArrayValue(data?.legalEntities, 'name')
    //     }
    //     setConfigPaymentData(businessUnit);
    //   },
    //   function (errMsg) {
    //     customToast("error", "high", errMsg);
    //   }
    // );

    getAllVisualizationFilterData(
      'payment_operations',
      {},
      function (data) {
        if (data) {
          let legalEntities = data.find(d => d.filterName === 'legalEntity');
          if (!isEmpty(legalEntities?.filterValues)) {
            let newBuList = legalEntities.filterValues.map(d => {
              return {
                code: d.name,
                description: "",
                name: d.title
              }
            });
            newBuList.sort((a, b) => (a.name.localeCompare(b.name)));
            setConfigPaymentData(newBuList);
          }
        }
      },
      function (err) {
        customToast("error", "high", err);
      }
    )

    getAllPspConfigs(
      function (data) {
        setLogo(data);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );

    getAllModalData(
      function (data) {
        setAllModalData(data);
        setCurrency(data?.currencyCodes);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );

    getPaymentMethod(
      function (paymentData) {
        setPaymentData(paymentData);
      },
      function (errorMsg) {
        setPaymentError(errorMsg);
      }
    );
  }, []);

  useEffect(() => {
    if (selectedBusinessUnit?.length > 0) {
      postPspConfigForFiltering(
        {
          legalEntities: selectedBusinessUnit,
        },

        function (data) {

          let filterCurrencies = []
          if (data?.currencyCodes?.length) {
            filterCurrencies = sortArrayValue(data?.currencyCodes, 'title')
          }
          setFilteredCurrency(filterCurrencies);
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [selectedBusinessUnit]);

  // Download and DropDown Component --- end

  useEffect(() => {
    const calendarInterval = getCalendarIntervalForGraph(selectedDropdownValue);
    const calendarIntervals = getCalendarInterval(selectedDropdownValue);

    if (selectedDropdownValue === "customDate" && !singleStartDate && (!startDate || !endDate)) {

      setLoading(false);
      return;
    }

    const dateRange =
      selectedDropdownValue === "customDate"
        ? getCustomDateRange(singleStartDate, startDate, endDate)
        : getUTCDayRange(selectedDropdownValue);
    const anotherDateRange =
      selectedDropdownValue === "customDate"
        ? getCustomDateRange(singleStartDate, startDate, endDate)
        : getUTCDayRangePercentage(selectedDropdownValue);

    if (
      (selectedDropdownValue &&
        selectedFilterCurrency) ||
      singleStartDate ||
      (startDate && endDate)
    ) {
      // sales chart --- start
      getAllVisualizationData(
        "transactions_overall_report",
        {
          ...dateRange,
          calendarInterval: calendarInterval,
          attributeFilters: {
            operationStatus: "Approved",
            operationName: ["Authorisation", "Sale"],
            currencyCode: selectedFilterCurrency,
            legalEntity: selectedBusinessUnit
          },
        },
        function (chartTransactionOverAll) {
          setChartTransactionOverAll(chartTransactionOverAll?.points);
          getAllVisualizationData(
            "gmv_overall_report",
            {
              ...dateRange,
              calendarInterval: calendarInterval,
              attributeFilters: {
                operationStatus: "Approved",
                operationName: ["Authorisation", "Sale"],
                currencyCode: selectedFilterCurrency,
                legalEntity: selectedBusinessUnit,
              },
            },
            function (volumeTransactionOverAll) {
              setVolumeTransactionOverAll(volumeTransactionOverAll?.points);
              setLoading(false);
            },
            function (errorMsg) {
              setPaymentError(errorMsg);
              setLoading(false);
            }
          );
        },
        function (errorMsg) {
          setPaymentError(errorMsg);
          setLoading(false);
        }
      );

      // sales chart --- end

      // transaction details --- start
      setPrevFlag(true);
      getAllVisualizationData(
        "success_rate_overall_aggs_report",
        {
          ...dateRange,
          attributeFilters: {
            operationName: ["Authorisation", "Sale"],
            currencyCode: selectedFilterCurrency,
            legalEntity: selectedBusinessUnit
          },
        },
        function (successRatePercentage) {
          // also used in Success Chart
          setSuccessRatePercentage(successRatePercentage?.points);

          getAllVisualizationData(
            "success_rate_overall_aggs_report",
            {
              ...anotherDateRange,
              attributeFilters: {
                operationName: ["Authorisation", "Sale"],
                currencyCode: selectedFilterCurrency,
                legalEntity: selectedBusinessUnit,
              },
            },
            function (successRateDifference) {
              if (successRateDifference?.points?.length === 0) {
                setPrevFlag(false);
              }
              setSuccessRateDifference(successRateDifference?.points);

              const preValue = successRateDifference?.points.map(
                (item) => item["successRate"]
              );
              const currentValue = successRatePercentage?.points.map(
                (item) => item["successRate"]
              );

              const preValueTotal =
                preValue.length > 0
                  ? preValue.reduce((sum, value) => sum + value, 0)
                  : 0;
              const currentValueTotal =
                currentValue.length > 0
                  ? currentValue.reduce((sum, value) => sum + value, 0)
                  : 0;

              const Difference =
                preValueTotal !== 0 ? currentValueTotal - preValueTotal : 0;
              setDifference(Difference?.toFixed(2));
            },
            function (errorMsg) {
              setPaymentError(errorMsg);
            }
          );
        },
        function (errorMsg) {
          setPaymentError(errorMsg);
        }
      );

      // transaction details --- end

      // Success Chart Details --- start
      //  successRatePercentage is also used
      getAllVisualizationData(
        "success_rate_psp_overall_report",
        {
          ...dateRange,
          calendarInterval: calendarInterval,
          attributeFilters: {
            currencyCode: selectedFilterCurrency,
            legalEntity: selectedBusinessUnit,
            operationName: ["Authorisation", "Sale"],
          },
        },
        function (successRateData) {
          let points = successRateData?.points;

          points.forEach((point) => {
            if (!("pspCode" in point)) {
              point["pspCode"] = "OVERALL";
              point["pspCodeLocale"] = "Overall";
            }
          });
          setSuccessRateDetails(points);
          setLoading(false);
        },
        function (errorMsg) {
          setPaymentError(errorMsg);
          setLoading(false);
        }
      );

      // Success Rate ends

      // Processor and Payment Method Card --- start

      const processorAndPaymentCategoryInterval = getCalendarInterval(
        selectedDropdownValue
      );

      const processorAndPaymentCategoryPayload = {
        ...dateRange,
        attributeFilters: {
          operationStatus: "Approved",
          operationName: ["Authorisation", "Sale"],
          currencyCode: selectedFilterCurrency,
          legalEntity: selectedBusinessUnit
        },
      };

      getAllVisualizationData("gmv_psp_aggs_report", processorAndPaymentCategoryPayload, function (gmvData) {
        let originalPoints = [...gmvData?.points];
        let modifiedPoints = [...originalPoints];
        if (originalPoints.length > 1) {
          modifiedPoints = [{
            pspCode: "OVERALL",
            pspCodeLocale: "Overall"
          }, ...originalPoints];
        }
        if (modifiedPoints?.length) {
          modifiedPoints = sortArrayValue(modifiedPoints, 'pspCodeLocale')
        }
        const sortedPoints = modifiedPoints.sort((a, b) => {
          if (a.pspCode === "OVERALL") return -1; // "OVERALL" comes first
          if (b.pspCode === "OVERALL") return 1;  // "OVERALL" comes first
          return 0; // Preserve order for other items
        });
        setGmvPspData(sortedPoints);
        setTransactionByPsp(originalPoints);
      },
        function (errorMsg) {
          setPaymentError(errorMsg);
        }
      );

      getAllVisualizationData(
        "gmv_payment_method_type_aggs_report",
        processorAndPaymentCategoryPayload,
        function (paymentMethodReport) {
          setPaymentMethodReport(paymentMethodReport?.points);
        },
        function (errorMsg) {
          setPaymentError(errorMsg);
        }
      );

      // Processor and Payment Method Card --- end
    } else {
      setLoading(false);
    }
  }, [
    selectedDropdownValue,
    refresh,
    selectedBusinessUnit,
    selectedFilterCurrency,
    singleStartDate,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    if (
      (selectedDropdownValue &&
        selectedBusinessUnit?.length > 0 &&
        selectedFilterCurrency) ||
      singleStartDate ||
      (startDate && endDate)
    ) {
      if (
        selectedDropdownValue === "customDate" &&
        !singleStartDate &&
        (!startDate || !endDate)
      ) {
        setLoading(false);
        return;
      }
      kpiCalls(
        getAllVisualizationData,
        selectedDropdownValue,
        {
          url: "overall_gmv_count_aggs_report",
          range: "today",
          offset: 0,
          title: "Transactional Value",
          fieldName: "gmv",
          attributeFilters: {
            operationStatus: "Approved",
            operationName: ["Authorisation", "Sale"],
            legalEntity: selectedBusinessUnit,
            currencyCode: selectedFilterCurrency,
          },
          localeFieldName: "gmvLocaleFull",
          // localeFieldName: "gmvLocale",
          singleStartDate: singleStartDate,
          startDate: startDate,
          endDate: endDate,
        },
        (data) => {
          setLoading(false);
          setTransactionVolumeData(data);
        },
        (errMsg) => {
          setLoading(false);
          customToast("error", "high", errMsg);
        }
      );
      kpiCalls(
        getAllVisualizationData,
        selectedDropdownValue,
        {
          url: "overall_gmv_count_aggs_report",
          range: "today",
          offset: 0,
          title: "Total Transactions",
          fieldName: "count",
          attributeFilters: {
            operationName: ["Authorisation", "Sale"],
            legalEntity: selectedBusinessUnit,
            currencyCode: selectedFilterCurrency,
          },
          localeFieldName: "countLocale",
          // localeFieldName: "countLocale",
          singleStartDate: singleStartDate,
          startDate: startDate,
          endDate: endDate,
        },
        (data) => {
          setLoading(false);
          setTotalPaymentData(data);
        },
        (errMsg) => {
          setLoading(false);
          customToast("error", "high", errMsg);
        }
      );

      kpiCalls(
        getAllVisualizationData,
        selectedDropdownValue,
        {
          url: "overall_gmv_count_aggs_report",
          range: "today",
          offset: 0,
          title: "Successful Transactions",
          fieldName: "count",
          attributeFilters: {
            operationStatus: "Approved",
            operationName: ["Authorisation", "Sale"],
            legalEntity: selectedBusinessUnit,
            currencyCode: selectedFilterCurrency,
          },
          singleStartDate: singleStartDate,
          localeFieldName: "countLocale",
          // localeFieldName: "countLocale",
          startDate: startDate,
          endDate: endDate,
        },
        (data) => {
          setLoading(false);
          setSuccessfulPaymentData(data);
        },
        (errMsg) => {
          setLoading(false);
          customToast("error", "high", errMsg);
        }
      );
    } else {
      setLoading(false);
    }
  }, [
    selectedDropdownValue,
    refresh,
    selectedBusinessUnit,
    selectedFilterCurrency,
    singleStartDate,
    startDate,
    endDate,
  ]);

  // success rate --- end

  // KPI --- start

  const showExternalStyling = true;
  const showDownloadIcon = false;
  const showRefreshIcon = true;
  const showDropdown = true;
  const showBusinessUnit = true;
  const showPercentageKpi = true;
  const showCurrency = true;

  const handleSingleStartDate = (data) => {
    setSingleStartDate(data);
  };

  const handleStartDate = (data) => {
    setStartDate(data);
  };
  const handleEndDate = (data) => {
    setendDate(data);
  };
  useEffect(() => {
    if (selectedDropdownValue !== "customDate") {
      setStartDate(null);
      setendDate(null);
      setSingleStartDate("");
    }
  }, [selectedDropdownValue]);
  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content">
          <div style={{ width: "100%" }}>
            <DownloadAndDropdown
              showDropdown={showDropdown}
              showDownloadIcon={showDownloadIcon}
              showRefreshIcon={showRefreshIcon}
              handleDropdownChange={handleDropdownChange}
              handleRefreshChange={handleRefreshButton}
              showBusinessUnit={showBusinessUnit}
              handleBussinessUnitChange={handleBussinessUnitChange}
              handleCurrencyFilterChange={handleCurrencyFilterChange}
              showCurrency={showCurrency}
              currency={filteredCurrency}
              configPaymentData={configPaymentData}
              setLoading={setLoading}
              handleSingleStartDate={handleSingleStartDate}
              singleStartDateValue={singleStartDate}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              startDateValue={startDate}
              endDateValue={endDate}
            />
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "32px",
            }}
          >
            <div style={{ width: "70%" }}>
              <div style={{ display: "flex" }}>
                {selectedDropdownValue &&
                  [...Array(3)].map((e, i) => (
                    <HomeKpi
                      key={i}
                      type={
                        i === 0
                          ? "totalPayment"
                          : i === 1
                            ? "successfulPayment"
                            : "transactionVolumne"
                      }
                      successfulPaymentData={successfulPaymentData}
                      totalPaymentData={totalPaymentData}
                      transactionVolumeData={transactionVolumeData}
                      selectedDropdownValue={selectedDropdownValue}
                      loading={loading}
                      singleStartDate={singleStartDate}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  ))}
              </div>
              <div
                style={{
                  width: "97%",
                  marginTop: "32px",
                  border: "1px solid #ECECEC",
                  borderRadius: "20px",
                  padding: "26px",
                  height: "412px",
                }}
              >
                {!loading ? (
                  locale !== "" && (
                    <SalesChart
                      selectedDropdownValue={selectedDropdownValue}
                      chartTransactionOverAll={chartTransactionOverAll}
                      volumeTransactionOverAll={volumeTransactionOverAll}
                      locale={locale}
                      singleStartDate={singleStartDate}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  )
                ) : (
                  <div>
                    <Skeleton variant="rectangular" width="100%" height={360} />
                  </div>
                )}
              </div>
            </div>
            <div style={{ width: "30%" }}>
              <TransactionDetails
                successRatePercentage={successRatePercentage}
                selectedDropdownValue={selectedDropdownValue}
                successRateDifference={successRateDifference}
                Difference={difference}
                prevFlag={prevFlag}
                loading={loading}
                singleStartDate={singleStartDate}
              />

              <div
                style={{
                  marginTop: "32px",
                  width: "100%",
                }}
              >
                <ProcessorAndPaymentCategoriesCard
                  gmvPspData={gmvPspData}
                  paymentData={paymentData}
                  paymentMethodReport={paymentMethodReport}
                  logo={logo}
                  className="paymentDiv"
                  title={title}
                  value={value}
                  showLeftIcon={true}
                  showRightIcon={true}
                  backgroundColor={backgroundColor}
                  loading={loading}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "32px",
            }}
          >
            <div style={{ width: "70%" }}>
              <div
                style={{
                  width: "97%",
                  border: "1px solid #ECECEC",
                  borderRadius: "20px",
                  padding: "26px 26px 0px 26px",
                  height: "412px",
                }}
              >
                {!loading ? (
                  <SuccessChart
                    successRateDetails={successRateDetails}
                    successRatePercentage={successRatePercentage}
                    selectedDropdownValue={selectedDropdownValue}
                    gmvPspData={gmvPspData}
                    handleFilterDropdown={handleFilterDropdown}
                    currencyCode={selectedFilterCurrency}
                    legalEntity={selectedBusinessUnit}
                    refresh={refresh}
                    singleStartDate={singleStartDate}
                    startDate={startDate}
                    endDate={endDate}
                  />
                ) : (
                  <>
                    <Skeleton variant="rectangular" width="100%" height={360} />
                  </>
                )}
              </div>
            </div>
            <div style={{ width: "30%" }}>
              <div>
                <ProcessorAndPaymentCategoriesCard
                  className="paymentDiv"
                  gmvPspData={transactionByPsp}
                  paymentData={paymentData}
                  paymentMethodReport={paymentMethodReport}
                  logo={logo}
                  title={title2}
                  value={value}
                  showLeftIcon={true}
                  showRightIcon={true}
                  backgroundColor={backgroundColor}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
